/**
 * Admin Communications page — re-uses the IT Portal CommunicationsTab.
 *
 * Same widgets, same APIs, same write permissions: country policies are
 * a business-level setting, so both Admin and IT operators must be able
 * to configure them. The component reads its locale via the IT Portal
 * i18n context, which falls back to ``navigator.language`` detection
 * when used outside the IT Portal — so this page renders correctly in
 * the Admin shell without further plumbing.
 */
import { CommunicationsTab } from "../components/it-portal/CommunicationsTab";

export default function AdminCommunicationsPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="admin-communications-page">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <CommunicationsTab />
      </div>
    </div>
  );
}
